import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";
import { registerServiceWorker } from "@/lib/pwa";

/**
 * Registers the offline shell (guarded) and shows a calm, dismissible banner
 * whenever the device loses connectivity, so users know a failed action is a
 * network problem rather than a broken app.
 */
export function OfflineBanner() {
  const [offline, setOffline] = useState(false);

  useEffect(() => {
    registerServiceWorker();

    const sync = () => setOffline(navigator.onLine === false);
    sync();
    window.addEventListener("online", sync);
    window.addEventListener("offline", sync);
    return () => {
      window.removeEventListener("online", sync);
      window.removeEventListener("offline", sync);
    };
  }, []);

  if (!offline) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed inset-x-0 top-0 z-[60] flex items-center justify-center gap-2 bg-foreground px-4 py-2 text-center text-xs font-medium text-background"
      style={{ paddingTop: "max(0.5rem, env(safe-area-inset-top))" }}
    >
      <WifiOff className="h-3.5 w-3.5" aria-hidden />
      You are offline — reconnect to post, comment or refresh.
    </div>
  );
}
